<div>
  <ng-content></ng-content>
  @if (isLoadingScroll) {
    <div class="flex h-full w-full items-center justify-center gap-2">
      <div>{{ 'loading' | translate }}...</div>
      <app-loader padding="0" [diameter]="'22'" height="100%"></app-loader>
    </div>
  }
  @if (isErrorScroll && !isLoadingScroll) {
    <div class="flex w-full items-center justify-center gap-2">
      <mat-error class="font-[14px]">
        {{ 'cannotLoadEmails' | translate }}
      </mat-error>
      <button mat-icon-button (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  }
  <div #sentinel class="h-[20px]"></div>
</div>
